<template>
  <Simplebar class="order-form-container">
    <form class="order-form" :class="{ sell: isSell }" novalidate>
      <MainOrder :position-num="positionNum" />
      <AttachOrder v-if="showAddOrder" />
      <OrderSubmit
        :order-submitting="orderSubmitting"
        :position-num="positionNum"
        @submit="submitOrder"
      />
      <!-- 交易密码 -->
      <TradePassword v-if="showTradePassword" @close="closeTradePassword" />
      <!--订单详情  -->
      <OrderConfirm
        :order="order"
        :type="hasModifyOrderRequest ? 'modify' : 'create'"
        :visible="showConfirmDialog"
        @closeConfirm="closeConfirmDialog"
      />
    </form>
  </Simplebar>
</template>
<script>
import { mapGetters } from 'vuex'
import Simplebar from 'com/SimpleBar'
import OrderConfirm from 'mod/TradeDialogs/OrderConfirm'
import OrderSubmit from './OrderSubmit'
import AttachOrder from './AttachOrder'
import MainOrder from './MainOrder'
import TradePassword from 'mod/TradeDialogs/TradePassword'
import orderTradeMixin from './mixins/orderTradeMixin'
import orderWatchMixin from './mixins/orderWatchMixin'
import { SEC_TYPE, MARKET_TYPE } from 'const/stock'
import { ORDER_TYPE } from 'const/trade'
export default {
  name: 'OrderForm',
  mixins: [orderTradeMixin, orderWatchMixin],
  components: {
    Simplebar,
    OrderConfirm,
    OrderSubmit,
    AttachOrder,
    MainOrder,
    TradePassword
  },
  data() {
    return {
      showConfirmDialog: false,
      showTradePassword: false,
      orderSubmitting: false,
      orderConfirmed: false,
      holding: null
    }
  },
  computed: {
    ...mapGetters([
      'hasModifyOrderRequest',
      'hasValidTradeToken',
      'hasTradeRequest',
      'tradeRequest',
      'isIb',
      'isVirtual',
      'curAccountId'
    ]),
    order() {
      return this.tradeRequest.order
    },
    stock() {
      return this.tradeRequest.stock
    },
    contract() {
      return this.tradeRequest.contract
    },
    minTicks() {
      return this.contract ? this.contract.tickSizes : []
    },
    positionNum() {
      return this.holding ? this.holding.position : 0
    },
    isSell() {
      return this.order.action === 'SELL'
    },
    showAddOrder() {
      return (
        this.isIb &&
        [MARKET_TYPE.US, MARKET_TYPE.HK].includes(this.stock.market) &&
        this.stock.secType === SEC_TYPE.STK &&
        this.order.orderType === ORDER_TYPE.LMT &&
        !this.hasModifyOrderRequest
      )
    }
  },

  watch: {
    curAccountId() {
      this.getCurrentStockHoldings()
    }
  },

  created() {
    this.$store.dispatch('getUserExchangeRate')
    this.getCurrentStockHoldings()
  },

  methods: {
    getCurrentStockHoldings() {
      this.$store.dispatch('getHoldingsBySymbol', this.stock).then(holdings => {
        this.holding = holdings[0]
      })
    }
  }
}
</script>
<style lang="less" scoped>
.order-form-container {
  flex: 1;
  min-height: 0;
}
</style>
